import instance from './common';

export default function getSelectedProfile() {
  return instance.get('/profiles?selected=true');
}
